import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost, apiPut } from "../api";

export interface MerchKind {
  id: number;
  code: string;
  name: string;
  active: boolean;
}

interface MerchKindListResponse {
  merch_kinds: MerchKind[];
}

export interface CreateMerchKindPayload {
  code: string;
  name: string;
  active?: boolean;
}

export type UpdateMerchKindPayload = Partial<Omit<CreateMerchKindPayload, "code">>;

export function useMerchKinds() {
  return useQuery<MerchKind[]>({
    queryKey: ["merch-kinds"],
    queryFn: async () => {
      const res = await apiGet<MerchKindListResponse>("/merch-kinds");
      return res.merch_kinds;
    },
  });
}

export function useCreateMerchKind() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateMerchKindPayload) =>
      apiPost<MerchKind>("/merch-kinds", payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["merch-kinds"] }),
  });
}

export function useUpdateMerchKind(id: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateMerchKindPayload) =>
      apiPut<MerchKind>(`/merch-kinds/${id}`, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["merch-kinds"] }),
  });
}
